import { AppointmentCtaSectionService } from "@lib/strapi/services/components/sections/appointmentCtaSection.service";
import { AppointmentFormSectionService } from "@lib/strapi/services/components/sections/appointmentFormSection.service";
import { BreadcrumbSectionService } from "@lib/strapi/services/components/sections/breadcrumbSection.service";
import { CareerFormSectionService } from "@lib/strapi/services/components/sections/careerFormSection.service";
import { ConditionsSectionService } from "@lib/strapi/services/components/sections/conditionsSection.service";
import { ContactFormSectionService } from "@lib/strapi/services/components/sections/contactFormSection.service";
import { ContentSectionService } from "@lib/strapi/services/components/sections/contentSection.service";
import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { FaqSectionService } from "@lib/strapi/services/components/sections/faqSection.service";
import { GoogleReviewsSectionService } from "@lib/strapi/services/components/sections/googleReviewsSection.service";
import { HeroSectionService } from "@lib/strapi/services/components/sections/heroSection.service";
import { LinksSectionService } from "@lib/strapi/services/components/sections/linksSection.service";
import { MapSectionService } from "@lib/strapi/services/components/sections/mapSection.service";
import { MarkdownSectionService } from "@lib/strapi/services/components/sections/markdownSection.service";
import { MenuSectionService } from "@lib/strapi/services/components/sections/menuSection.service";
import { NewsletterSectionService } from "@lib/strapi/services/components/sections/newsletterSection.service";
import { NoticeSectionService } from "@lib/strapi/services/components/sections/noticeSection.service";
import { PageHeadingService } from "@lib/strapi/services/components/shared/pageHeading.service";
import { PostDetailSectionService } from "@lib/strapi/services/components/sections/postDetailSection.service";
import { PostsSectionService } from "@lib/strapi/services/components/sections/postsSection.service";
import { RelatedSectionService } from "@lib/strapi/services/components/sections/relatedSection.service";
import { StatsSectionService } from "@lib/strapi/services/components/sections/statsSection.service";
import { StepsSectionService } from "@lib/strapi/services/components/sections/stepsSection.service";
import {
  StrapiAppointmentCtaSectionDTO,
  AppointmentCtaSectionDTO,
} from "@lib/strapi/dtos/components/sections/appointmentCtaSection.dto";
import {
  StrapiAppointmentFormSectionDTO,
  AppointmentFormSectionDTO,
} from "@lib/strapi/dtos/components/sections/appointmentFormSection.dto";
import {
  StrapiCareerFormSectionDTO,
  CareerFormSectionDTO,
} from "@lib/strapi/dtos/components/sections/careerFormSection.dto";
import {
  StrapiConditionsSectionDTO,
  ConditionsSectionDTO,
} from "@lib/strapi/dtos/components/sections/conditionsSection.dto";
import {
  StrapiContactFormSectionDTO,
  ContactFormSectionDTO,
} from "@lib/strapi/dtos/components/sections/contactFormSection.dto";
import {
  StrapiContentSectionDTO,
  ContentSectionDTO,
} from "@lib/strapi/dtos/components/sections/contentSection.dto";
import {
  StrapiFaqSectionDTO,
  FaqSectionDTO,
} from "@lib/strapi/dtos/components/sections/faqSection.dto";
import {
  StrapiGoogleReviewsSectionDTO,
  GoogleReviewsSectionDTO,
} from "@lib/strapi/dtos/components/sections/googleReviewsSection.dto";
import {
  StrapiHeroSectionDTO,
  HeroSectionDTO,
} from "@lib/strapi/dtos/components/sections/heroSection.dto";
import {
  StrapiLinksSectionDTO,
  LinksSectionDTO,
} from "@lib/strapi/dtos/components/sections/linksSection.dto";
import {
  StrapiMapSectionDTO,
  MapSectionDTO,
} from "@lib/strapi/dtos/components/sections/mapSection.dto";
import {
  StrapiMarkdownSectionDTO,
  MarkdownSectionDTO,
} from "@lib/strapi/dtos/components/sections/markdownSection.dto";
import {
  StrapiMenuSectionDTO,
  MenuSectionDTO,
} from "@lib/strapi/dtos/components/sections/menuSection.dto";
import {
  StrapiNewsletterSectionDTO,
  NewsletterSectionDTO,
} from "@lib/strapi/dtos/components/sections/newsletterSection.dto";
import {
  StrapiNoticeSectionDTO,
  NoticeSectionDTO,
} from "@lib/strapi/dtos/components/sections/noticeSection.dto";
import {
  StrapiPageHeadingDTO,
  PageHeadingDTO,
} from "@lib/strapi/dtos/components/shared/pageHeading.dto";
import { StrapiPages } from "@lib/strapi/pages";
import {
  StrapiPostDetailSectionDTO,
  PostDetailSectionDTO,
} from "@lib/strapi/dtos/components/sections/postDetailSection.dto";
import {
  StrapiPostsSectionDTO,
  PostsSectionDTO,
} from "@lib/strapi/dtos/components/sections/postsSection.dto";
import {
  StrapiRelatedSectionDTO,
  RelatedSectionDTO,
} from "@lib/strapi/dtos/components/sections/relatedSection.dto";
import { StrapiResponse } from "@lib/strapi/dtos/core/response.dto";
import { StrapiRoutes } from "@lib/strapi/routes";
import {
  StrapiStatsSectionDTO,
  StatsSectionDTO,
} from "@lib/strapi/dtos/components/sections/statsSection.dto";
import {
  StrapiStepsSectionDTO,
  StepsSectionDTO,
} from "@lib/strapi/dtos/components/sections/stepsSection.dto";
import {
  StrapiTeamSectionDTO,
  TeamSectionDTO,
} from "@lib/strapi/dtos/components/sections/teamSection.dto";
import {
  StrapiTreatmentsSectionDTO,
  TreatmentsSectionDTO,
} from "@lib/strapi/dtos/components/sections/treatmentsSection.dto";
import {
  StrapiVideoSectionDTO,
  VideoSectionDTO,
} from "@lib/strapi/dtos/components/sections/videoSection.dto";
import {
  StrapiWebPageDTO,
  WebPageDTO,
} from "@lib/strapi/dtos/content-types/webPage.dto";
import { TeamSectionService } from "@lib/strapi/services/components/sections/teamSection.service";
import { TreatmentsSectionService } from "@lib/strapi/services/components/sections/treatmentsSection.service";
import { VideoSectionService } from "@lib/strapi/services/components/sections/videoSection.service";
import { fetchAPI } from "@lib/strapi/fetch-api";

export class WebPageService {
  static async fromStrapi(
    dto: WebPageDTO,
    locale: string,
    strapiData?: StrapiWebPageDTO,
  ): Promise<WebPageDTO> {
    if (!strapiData) {
      return null;
    }
    if (dto == null) {
      dto = new WebPageDTO();
    }
    dto.title = strapiData.title;
    dto.slug = strapiData.slug;
    dto.headingZone = await Promise.all(
      (strapiData.headingZone ?? []).map(
        async (item) =>
          await WebPageService.getheadingZoneComponentProps(locale, item),
      ),
    );
    dto.breadcrumb = await BreadcrumbSectionService.fromStrapi(
      locale,
      strapiData.breadcrumb,
    );
    dto.contentSections = await Promise.all(
      (strapiData.contentSections ?? []).map(
        async (item) =>
          await WebPageService.getcontentSectionsComponentProps(locale, item),
      ),
    );
    dto.asideSections = await Promise.all(
      (strapiData.asideSections ?? []).map(
        async (item) =>
          await WebPageService.getasideSectionsComponentProps(locale, item),
      ),
    );
    dto.bottomSections = await Promise.all(
      (strapiData.bottomSections ?? []).map(
        async (item) =>
          await WebPageService.getbottomSectionsComponentProps(locale, item),
      ),
    );
    dto.contentWidth = strapiData.contentWidth;
    dto.seo = strapiData.seo;
    return dto;
  }

  static async getheadingZoneComponentProps(
    locale: string,
    strapiData: StrapiDynamicZoneComponentDTO,
  ): Promise<DynamicZoneComponentDTO> {
    switch (strapiData.__component) {
      case "shared.page-heading":
        return await PageHeadingService.fromStrapi(
          locale,
          strapiData as StrapiPageHeadingDTO,
        );
      case "sections.hero-section":
        return await HeroSectionService.fromStrapi(
          locale,
          strapiData as StrapiHeroSectionDTO,
        );
    }
    return { ...strapiData };
  }

  static async getcontentSectionsComponentProps(
    locale: string,
    strapiData: StrapiDynamicZoneComponentDTO,
  ): Promise<DynamicZoneComponentDTO> {
    switch (strapiData.__component) {
      case "sections.markdown-section":
        return await MarkdownSectionService.fromStrapi(
          locale,
          strapiData as StrapiMarkdownSectionDTO,
        );
      case "sections.content-section":
        return await ContentSectionService.fromStrapi(
          locale,
          strapiData as StrapiContentSectionDTO,
        );
      case "sections.hero-section":
        return await HeroSectionService.fromStrapi(
          locale,
          strapiData as StrapiHeroSectionDTO,
        );
      case "sections.stats-section":
        return await StatsSectionService.fromStrapi(
          locale,
          strapiData as StrapiStatsSectionDTO,
        );
      case "sections.steps-section":
        return await StepsSectionService.fromStrapi(
          locale,
          strapiData as StrapiStepsSectionDTO,
        );
      case "sections.faq-section":
        return await FaqSectionService.fromStrapi(
          locale,
          strapiData as StrapiFaqSectionDTO,
        );
      case "sections.treatments-section":
        return await TreatmentsSectionService.fromStrapi(
          locale,
          strapiData as StrapiTreatmentsSectionDTO,
        );
      case "sections.conditions-section":
        return await ConditionsSectionService.fromStrapi(
          locale,
          strapiData as StrapiConditionsSectionDTO,
        );
      case "sections.related-section":
        return await RelatedSectionService.fromStrapi(
          locale,
          strapiData as StrapiRelatedSectionDTO,
        );
      case "sections.team-section":
        return await TeamSectionService.fromStrapi(
          locale,
          strapiData as StrapiTeamSectionDTO,
        );
      case "sections.google-reviews-section":
        return await GoogleReviewsSectionService.fromStrapi(
          locale,
          strapiData as StrapiGoogleReviewsSectionDTO,
        );
      case "sections.appointment-cta-section":
        return await AppointmentCtaSectionService.fromStrapi(
          locale,
          strapiData as StrapiAppointmentCtaSectionDTO,
        );
      case "sections.appointment-form-section":
        return await AppointmentFormSectionService.fromStrapi(
          locale,
          strapiData as StrapiAppointmentFormSectionDTO,
        );
      case "sections.contact-form-section":
        return await ContactFormSectionService.fromStrapi(
          locale,
          strapiData as StrapiContactFormSectionDTO,
        );
      case "sections.career-form-section":
        return await CareerFormSectionService.fromStrapi(
          locale,
          strapiData as StrapiCareerFormSectionDTO,
        );
      case "sections.newsletter-section":
        return await NewsletterSectionService.fromStrapi(
          locale,
          strapiData as StrapiNewsletterSectionDTO,
        );
      case "sections.posts-section":
        return await PostsSectionService.fromStrapi(
          locale,
          strapiData as StrapiPostsSectionDTO,
        );
      case "sections.post-detail-section":
        return await PostDetailSectionService.fromStrapi(
          locale,
          strapiData as StrapiPostDetailSectionDTO,
        );
      case "sections.video-section":
        return await VideoSectionService.fromStrapi(
          locale,
          strapiData as StrapiVideoSectionDTO,
        );
      case "sections.map-section":
        return await MapSectionService.fromStrapi(
          locale,
          strapiData as StrapiMapSectionDTO,
        );
      case "sections.links-section":
        return await LinksSectionService.fromStrapi(
          locale,
          strapiData as StrapiLinksSectionDTO,
        );
      case "sections.notice-section":
        return await NoticeSectionService.fromStrapi(
          locale,
          strapiData as StrapiNoticeSectionDTO,
        );
    }
    return { ...strapiData };
  }

  static async getasideSectionsComponentProps(
    locale: string,
    strapiData: StrapiDynamicZoneComponentDTO,
  ): Promise<DynamicZoneComponentDTO> {
    switch (strapiData.__component) {
      case "sections.menu-section":
        return await MenuSectionService.fromStrapi(
          locale,
          strapiData as StrapiMenuSectionDTO,
        );
      case "sections.appointment-cta-section":
        return await AppointmentCtaSectionService.fromStrapi(
          locale,
          strapiData as StrapiAppointmentCtaSectionDTO,
        );
      case "sections.markdown-section":
        return await MarkdownSectionService.fromStrapi(
          locale,
          strapiData as StrapiMarkdownSectionDTO,
        );
      case "sections.links-section":
        return await LinksSectionService.fromStrapi(
          locale,
          strapiData as StrapiLinksSectionDTO,
        );
    }
    return { ...strapiData };
  }

  static async getbottomSectionsComponentProps(
    locale: string,
    strapiData: StrapiDynamicZoneComponentDTO,
  ): Promise<DynamicZoneComponentDTO> {
    switch (strapiData.__component) {
      case "sections.appointment-cta-section":
        return await AppointmentCtaSectionService.fromStrapi(
          locale,
          strapiData as StrapiAppointmentCtaSectionDTO,
        );
      case "sections.google-reviews-section":
        return await GoogleReviewsSectionService.fromStrapi(
          locale,
          strapiData as StrapiGoogleReviewsSectionDTO,
        );
      case "sections.stats-section":
        return await StatsSectionService.fromStrapi(
          locale,
          strapiData as StrapiStatsSectionDTO,
        );
      case "sections.newsletter-section":
        return await NewsletterSectionService.fromStrapi(
          locale,
          strapiData as StrapiNewsletterSectionDTO,
        );
      case "sections.content-section":
        return await ContentSectionService.fromStrapi(
          locale,
          strapiData as StrapiContentSectionDTO,
        );
      case "sections.video-section":
        return await VideoSectionService.fromStrapi(
          locale,
          strapiData as StrapiVideoSectionDTO,
        );
    }
    return { ...strapiData };
  }

  static async fetchBySlug(
    authToken: string,
    locale: string,
    slug?: string,
  ): Promise<WebPageDTO> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = { locale, filters: { slug: slug } };
    const response: StrapiResponse<StrapiWebPageDTO[]> = await fetchAPI(
      StrapiRoutes.webPages(),
      urlParamsObject,
      token,
    );
    const dto = new WebPageDTO();
    if ((response.data ?? []).length === 0) {
      return null;
    }
    return await WebPageService.fromStrapi(
      dto,
      locale,
      (response.data ?? [])[0],
    );
  }
}
